import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Escape } from '../../../../services/Escape';
import { useDisablePageScroll } from '../../../../internal/hooks/useDisablePageScroll';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для рендера модальных окон
 */
export var Modal = /*#__PURE__*/React.memo(function (_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    children = _ref.children,
    _ref$escape = _ref.escape,
    escape = _ref$escape === void 0 ? true : _ref$escape,
    _ref$portal = _ref.portal,
    portal = _ref$portal === void 0 ? true : _ref$portal;
  var host = typeof document !== 'undefined' ? document.body : null;
  useDisablePageScroll(open);
  if (!host || !open) {
    return null;
  }
  var component = /*#__PURE__*/_jsx(Escape, {
    onEscape: onClose,
    active: !!escape,
    children: children
  });
  return portal ? /*#__PURE__*/ReactDOM.createPortal(component, host) : component;
});
Modal.displayName = 'Modal';